<template>
  <div class="about-page">
    <!-- 简化导航栏 -->
    <header class="nav-header">
      <h1 class="nav-title">关于我们</h1>
    </header>

    <!-- 主横幅 -->
    <section class="hero-section">
      <div class="hero-image-container">
        <img class="hero-image" src="/assets/about1.png" alt="关于我们" />
        <div class="hero-overlay">
          <div class="hero-content">
            <h1 class="hero-title">关于我们</h1>
            <p class="hero-subtitle">ABOUT US</p>
            <div class="hero-divider"></div>
            <p class="hero-description">专注AI创新，筑梦数字未来</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 公司简介 -->
    <section class="company-intro">
      <div class="section-container">
        <div class="intro-header">
          <h2 class="section-title">神笔（南京）软件有限责任公司</h2>
          <div class="title-underline"></div>
        </div>
        
        <div class="intro-content">
          <div class="intro-card">
            <div class="card-icon">🚀</div>
            <div class="card-content">
              <h3>创立背景</h3>
              <p>神笔软件成立于2021年，是江苏省高新技术企业，中小科技型企业，是领先的MDA元宇宙智能软件公司。</p>
            </div>
          </div>

          <div class="intro-card">
            <div class="card-icon">🎯</div>
            <div class="card-content">
              <h3>产品矩阵</h3>
              <p>公司推出神小笔、神小童、神笔小新等系列智能产品，为用户提供全方位的AI创意解决方案。</p>
            </div>
          </div>

          <div class="intro-card">
            <div class="card-icon">💡</div>
            <div class="card-content">
              <h3>使命愿景</h3>
              <p>诚挚感谢用户的支持和使用，您们的极致体验是我们追求的目标。致力于让AI技术服务于每一个人的创意需求。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心优势 -->
    <section class="advantages-section">
      <div class="section-container">
        <h2 class="section-title">核心优势</h2>
        <div class="title-underline centered"></div>
        
        <div class="advantages-grid">
          <div class="advantage-item" v-for="(advantage, index) in advantages" :key="index">
            <div class="advantage-icon">{{ advantage.icon }}</div>
            <h3 class="advantage-title">{{ advantage.title }}</h3>
            <p class="advantage-desc">{{ advantage.description }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 发展历程 -->
    <section class="timeline-section">
      <div class="section-container">
        <h2 class="section-title">发展历程</h2>
        <div class="title-underline centered"></div>
        
        <div class="timeline">
          <div class="timeline-item" v-for="(milestone, index) in milestones" :key="index">
            <div class="timeline-dot"></div>
            <div class="timeline-content">
              <div class="timeline-year">{{ milestone.year }}</div>
              <div class="timeline-title">{{ milestone.title }}</div>
              <div class="timeline-desc">{{ milestone.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 联系我们 -->
    <section class="contact-section">
      <div class="contact-background">
        <div class="background-shapes">
          <div class="shape shape-1"></div>
          <div class="shape shape-2"></div>
          <div class="shape shape-3"></div>
        </div>
        
        <div class="section-container">
          <div class="contact-header">
            <h2 class="section-title white">联系我们</h2>
            <p class="contact-subtitle">让我们一起探索AI的无限可能</p>
            <div class="title-underline white centered"></div>
          </div>
          
          <div class="contact-cards">
            <div class="contact-card" data-aos="fade-up" data-aos-delay="100">
              <div class="card-glow"></div>
              <div class="contact-icon-wrapper">
                <div class="contact-icon-bg">
                  <svg class="contact-svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <circle cx="12" cy="10" r="3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div class="contact-content">
                <h3>公司地址</h3>
                <p>南京市建邺区云龙山路100号<br>信安大厦A座5层505</p>
              </div>
            </div>

            <div class="contact-card" data-aos="fade-up" data-aos-delay="200">
              <div class="card-glow"></div>
              <div class="contact-icon-wrapper">
                <div class="contact-icon-bg">
                  <svg class="contact-svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="m4 4 16 16" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="m22 6-3-3a2 2 0 0 0-3 0L4 15v5h5L21 8a2 2 0 0 0 0-3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div class="contact-content">
                <h3>联系邮箱</h3>
                <p>jiwei@magicpensoft.com</p>
                <div class="email-badge">商务合作</div>
              </div>
            </div>

            <div class="contact-card" data-aos="fade-up" data-aos-delay="300">
              <div class="card-glow"></div>
              <div class="contact-icon-wrapper">
                <div class="contact-icon-bg">
                  <svg class="contact-svg-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <line x1="2" y1="12" x2="22" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              </div>
              <div class="contact-content">
                <h3>合作咨询</h3>
                <p>欢迎与我们探讨<br>AI领域的合作机会</p>
                <div class="partnership-tags">
                  <span class="tag">技术合作</span>
                  <span class="tag">商务洽谈</span>
                </div>
              </div>
            </div>
          </div>

          <!-- 联系行动区域 -->
          <div class="contact-cta">
            <div class="cta-content">
              <h3>开启AI创新之旅</h3>
              <p>与我们一起，让创意无界，让未来可期</p>
              <button class="cta-button" onclick="window.open('mailto:jiwei@magicpensoft.com')">
                <span>立即联系</span>
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <line x1="7" y1="17" x2="17" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <polyline points="7,7 17,7 17,17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 底部空间 -->
    <div class="bottom-spacer"></div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

// 核心优势数据
const advantages = ref([
  {
    icon: '🧠',
    title: '技术创新',
    description: '拥有自主研发的AI核心技术，持续推动人工智能领域的创新突破'
  },
  {
    icon: '🎨',
    title: '创意设计',
    description: '专业的设计团队和创意理念，为用户提供优质的视觉体验'
  },
  {
    icon: '⚡',
    title: '高效服务',
    description: '快速响应用户需求，提供7x24小时的技术支持和服务保障'
  },
  {
    icon: '🤝',
    title: '合作共赢',
    description: '与众多企业建立战略合作关系，共同推进AI技术的产业化应用'
  }
])

// 发展历程数据
const milestones = ref([
  {
    year: '2021',
    title: '公司成立',
    description: '神笔软件正式成立，开始专注于AI创意软件的研发'
  },
  {
    year: '2022',
    title: '产品发布',
    description: '推出神小笔系列产品，获得用户广泛认可'
  },
  {
    year: '2023',
    title: '技术突破',
    description: '在AI视频生成领域取得重大技术突破，产品功能大幅提升'
  },
  {
    year: '2024',
    title: '生态建设',
    description: '构建完善的AI创意生态系统，服务数百万用户'
  }
])
</script>

<style lang="scss" scoped>
// 全局变量 - 白色主题
:root {
  --primary-color: #2490ff;
  --secondary-color: #67c23a;
  --text-primary: #303133;
  --text-secondary: #606266;
  --text-light: #909399;
  --bg-white: #ffffff;
  --bg-light: #f8f9fa;
  --shadow-light: 0 2px 12px rgba(0, 0, 0, 0.1);
  --shadow-medium: 0 4px 20px rgba(0, 0, 0, 0.15);
  --border-radius: 12px;
  --transition: all 0.3s ease;
}

.about-page {
  min-height: 100vh;
  background: var(--bg-light);
  color: var(--text-primary);
}

// 简化导航栏
.nav-header {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 20px;
  background: var(--bg-white);
  backdrop-filter: blur(10px);
  box-shadow: var(--shadow-light);
  
  .nav-title {
    font-size: 20px;
    font-weight: 600;
    margin: 0;
    color: var(--text-primary);
  }
}

// 主横幅
.hero-section {
  position: relative;
  
  .hero-image-container {
    position: relative;
    width: 100%;
    overflow: hidden;
    
    .hero-image {
      width: 100%;
      height: auto;
      display: block;
    }
    
    .hero-overlay {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, rgba(36, 144, 255, 0.8), rgba(103, 194, 58, 0.6));
      display: flex;
      align-items: center;
      justify-content: center;
      
      .hero-content {
        text-align: center;
        color: white;
        padding: 20px;
        
        .hero-title {
          font-size: 36px;
          font-weight: 700;
          margin: 0 0 8px 0;
          letter-spacing: 2px;
          text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
        }
        
        .hero-subtitle {
          font-size: 16px;
          font-weight: 300;
          letter-spacing: 4px;
          margin: 0 0 20px 0;
          opacity: 0.9;
        }
        
        .hero-divider {
          width: 60px;
          height: 3px;
          background: white;
          margin: 0 auto 20px auto;
          border-radius: 2px;
        }
        
        .hero-description {
          font-size: 18px;
          font-weight: 400;
          margin: 0;
          opacity: 0.95;
        }
      }
    }
  }
}

// 通用容器
.section-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

// 通用标题样式
.section-title {
  font-size: 28px;
  font-weight: 700;
  text-align: center;
  margin: 0 0 12px 0;
  color: var(--text-primary);
  
  &.white {
    color: white;
  }
}

.title-underline {
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, var(--primary-color), var(--secondary-color));
  border-radius: 2px;
  margin-bottom: 40px;
  
  &.centered {
    margin-left: auto;
    margin-right: auto;
  }
  
  &.white {
    background: linear-gradient(90deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.7));
  }
}

// 公司简介区域
.company-intro {
  padding: 60px 0;
  background: var(--bg-white);
  
  .intro-header {
    margin-bottom: 50px;
  }
  
  .intro-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }
  
  .intro-card {
    display: flex;
    align-items: flex-start;
    gap: 20px;
    padding: 30px;
    background: var(--bg-light);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-light);
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-5px);
      box-shadow: var(--shadow-medium);
    }
    
    .card-icon {
      font-size: 32px;
      width: 60px;
      height: 60px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--primary-color);
      border-radius: 50%;
      flex-shrink: 0;
    }
    
    .card-content {
      flex: 1;
      
      h3 {
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 12px 0;
        color: var(--text-primary);
      }
      
      p {
        font-size: 16px;
        line-height: 1.6;
        margin: 0;
        color: var(--text-secondary);
      }
    }
  }
}

// 核心优势区域
.advantages-section {
  padding: 60px 0;
  background: var(--bg-light);
  
  .advantages-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 30px;
    margin-top: 40px;
  }
  
  .advantage-item {
    text-align: center;
    padding: 40px 20px;
    background: var(--bg-white);
    border-radius: var(--border-radius);
    box-shadow: var(--shadow-light);
    transition: var(--transition);
    
    &:hover {
      transform: translateY(-10px);
      box-shadow: var(--shadow-medium);
    }
    
    .advantage-icon {
      font-size: 48px;
      margin-bottom: 20px;
    }
    
    .advantage-title {
      font-size: 20px;
      font-weight: 600;
      margin: 0 0 16px 0;
      color: var(--text-primary);
    }
    
    .advantage-desc {
      font-size: 14px;
      line-height: 1.6;
      margin: 0;
      color: var(--text-secondary);
    }
  }
}

// 发展历程区域
.timeline-section {
  padding: 60px 0;
  background: var(--bg-white);
  
  .timeline {
    position: relative;
    margin-top: 40px;
    
    &::before {
      content: '';
      position: absolute;
      left: 30px;
      top: 0;
      bottom: 0;
      width: 3px;
      background: linear-gradient(180deg, var(--primary-color), var(--secondary-color));
      border-radius: 2px;
    }
  }
  
  .timeline-item {
    position: relative;
    margin-bottom: 40px;
    padding-left: 80px;
    
    &:last-child {
      margin-bottom: 0;
    }
    
    .timeline-dot {
      position: absolute;
      left: 18px;
      top: 8px;
      width: 24px;
      height: 24px;
      background: var(--primary-color);
      border: 4px solid var(--bg-white);
      border-radius: 50%;
      box-shadow: var(--shadow-light);
    }
    
    .timeline-content {
      background: var(--bg-light);
      padding: 24px;
      border-radius: var(--border-radius);
      box-shadow: var(--shadow-light);
      
      .timeline-year {
        font-size: 18px;
        font-weight: 700;
        color: var(--primary-color);
        margin-bottom: 8px;
      }
      
      .timeline-title {
        font-size: 20px;
        font-weight: 600;
        color: var(--text-primary);
        margin-bottom: 12px;
      }
      
      .timeline-desc {
        font-size: 14px;
        line-height: 1.6;
        color: var(--text-secondary);
        margin: 0;
      }
    }
  }
}

// 联系我们区域
.contact-section {
  .contact-background {
    position: relative;
    background: linear-gradient(135deg, 
      #667eea 0%, 
      #764ba2 25%, 
      #f093fb 50%, 
      #f5576c 75%, 
      #4facfe 100%);
    background-size: 400% 400%;
    animation: gradientShift 8s ease infinite;
    min-height: 600px;
    padding: 80px 0;
    overflow: hidden;
    
    .background-shapes {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      
      .shape {
        position: absolute;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.1);
        animation: float 6s ease-in-out infinite;
        
        &.shape-1 {
          width: 200px;
          height: 200px;
          top: 10%;
          right: 10%;
          animation-delay: 0s;
        }
        
        &.shape-2 {
          width: 150px;
          height: 150px;
          bottom: 20%;
          left: 5%;
          animation-delay: 2s;
        }
        
        &.shape-3 {
          width: 100px;
          height: 100px;
          top: 50%;
          right: 30%;
          animation-delay: 4s;
        }
      }
    }
  }
  
  .contact-header {
    text-align: center;
    margin-bottom: 60px;
    
    .contact-subtitle {
      font-size: 18px;
      color: rgba(255, 255, 255, 0.9);
      margin: 16px 0 30px;
      font-weight: 300;
    }
  }
  
  .contact-cards {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 30px;
    margin-bottom: 60px;
  }
  
  .contact-card {
    position: relative;
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 30px;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    
    &:hover {
      transform: translateY(-10px);
      background: rgba(255, 255, 255, 0.15);
      box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
      
      .card-glow {
        opacity: 1;
      }
      
      .contact-icon-bg {
        transform: scale(1.1);
      }
    }
    
    .card-glow {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, 
        rgba(255, 255, 255, 0.1), 
        rgba(255, 255, 255, 0.05));
      border-radius: 20px;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
    }
    
    .contact-icon-wrapper {
      margin-bottom: 24px;
      
      .contact-icon-bg {
        width: 70px;
        height: 70px;
        background: linear-gradient(135deg, #fff, #f0f0f0);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
        transition: transform 0.3s ease;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        
        .contact-svg-icon {
          width: 28px;
          height: 28px;
          color: #667eea;
        }
      }
    }
    
    .contact-content {
      h3 {
        font-size: 20px;
        font-weight: 600;
        margin: 0 0 12px 0;
        color: white;
      }
      
      p {
        font-size: 16px;
        line-height: 1.6;
        margin: 0 0 16px 0;
        color: rgba(255, 255, 255, 0.9);
      }
      
      .email-badge {
        display: inline-block;
        background: linear-gradient(135deg, #ff6b6b, #feca57);
        color: white;
        padding: 6px 12px;
        border-radius: 20px;
        font-size: 12px;
        font-weight: 500;
      }
      
      .partnership-tags {
        display: flex;
        gap: 8px;
        justify-content: center;
        flex-wrap: wrap;
        
        .tag {
          background: rgba(255, 255, 255, 0.2);
          color: white;
          padding: 4px 10px;
          border-radius: 15px;
          font-size: 12px;
          font-weight: 500;
          border: 1px solid rgba(255, 255, 255, 0.3);
        }
      }
    }
  }
  
  .contact-cta {
    text-align: center;
    
    .cta-content {
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(20px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 25px;
      padding: 40px;
      max-width: 500px;
      margin: 0 auto;
      
      h3 {
        font-size: 24px;
        font-weight: 600;
        margin: 0 0 12px 0;
        color: white;
      }
      
      p {
        font-size: 16px;
        color: rgba(255, 255, 255, 0.9);
        margin: 0 0 30px 0;
        line-height: 1.6;
      }
      
      .cta-button {
        background: linear-gradient(135deg, #667eea, #764ba2);
        border: none;
        border-radius: 50px;
        padding: 15px 35px;
        color: white;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.3s ease;
        display: inline-flex;
        align-items: center;
        gap: 10px;
        box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
        }
        
        svg {
          width: 18px;
          height: 18px;
          transition: transform 0.3s ease;
        }
        
        &:hover svg {
          transform: translate(2px, -2px);
        }
      }
    }
  }
}

// 动画定义
@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

@keyframes float {
  0%, 100% {
    transform: translateY(0px) rotate(0deg);
  }
  33% {
    transform: translateY(-10px) rotate(2deg);
  }
  66% {
    transform: translateY(5px) rotate(-2deg);
  }
}

// 底部空间
.bottom-spacer {
  height: 100px;
}

// 响应式设计
@media (max-width: 768px) {
  .hero-content .hero-title {
    font-size: 28px;
  }
  
  .section-title {
    font-size: 24px;
  }
  
  .intro-card {
    flex-direction: column;
    text-align: center;
    
    .card-icon {
      align-self: center;
    }
  }
  
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  .timeline::before {
    left: 15px;
  }
  
  .timeline-item {
    padding-left: 50px;
    
    .timeline-dot {
      left: 3px;
    }
  }
  
  // 联系我们响应式
  .contact-section {
    .contact-background {
      padding: 60px 0;
      min-height: 500px;
    }
    
    .contact-header {
      margin-bottom: 40px;
      
      .contact-subtitle {
        font-size: 16px;
      }
    }
    
    .contact-cards {
      grid-template-columns: 1fr;
      gap: 20px;
      margin-bottom: 40px;
    }
    
    .contact-card {
      padding: 25px 20px;
      
      .contact-icon-wrapper .contact-icon-bg {
        width: 60px;
        height: 60px;
        
        .contact-svg-icon {
          width: 24px;
          height: 24px;
        }
      }
      
      .contact-content {
        h3 {
          font-size: 18px;
        }
        
        p {
          font-size: 15px;
        }
        
        .partnership-tags {
          .tag {
            font-size: 11px;
            padding: 3px 8px;
          }
        }
      }
    }
    
    .contact-cta .cta-content {
      padding: 30px 20px;
      
      h3 {
        font-size: 20px;
      }
      
      p {
        font-size: 14px;
      }
      
      .cta-button {
        padding: 12px 25px;
        font-size: 14px;
        
        svg {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .section-container {
    padding: 0 16px;
  }
  
  .hero-content .hero-title {
    font-size: 24px;
  }
  
  .intro-card, .timeline-content {
    padding: 20px;
  }
  
  .advantage-item {
    padding: 30px 16px;
  }
}

// 动画效果
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.intro-card, .advantage-item, .timeline-item {
  animation: fadeInUp 0.6s ease-out;
}

// 滚动条样式 - 白色主题
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background: var(--primary-color);
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #1976d2;
}

// 强制白色主题，覆盖系统深色模式
@media (prefers-color-scheme: dark) {
  .about-page {
    // 强制使用浅色主题变量，即使在深色模式下
    --primary-color: #2490ff;
    --secondary-color: #67c23a;
    --text-primary: #303133;
    --text-secondary: #606266;
    --text-light: #909399;
    --bg-white: #ffffff;
    --bg-light: #f8f9fa;
    --shadow-light: 0 2px 12px rgba(0, 0, 0, 0.1);
    --shadow-medium: 0 4px 20px rgba(0, 0, 0, 0.15);
    
    // 强制白色背景和深色文字
    background: #f8f9fa !important;
    color: #303133 !important;
  }

  .nav-header {
    background: #ffffff !important;
    color: #303133 !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1) !important;
  }

  .company-intro {
    background: #ffffff !important;
  }

  .advantages-section {
    background: #f8f9fa !important;
  }

  .timeline-section {
    background: #ffffff !important;
  }

  // 强制所有文字为深色
  .section-title,
  .intro-card h3,
  .intro-card p,
  .advantage-title,
  .advantage-desc,
  .timeline-year,
  .timeline-title,
  .timeline-desc {
    color: #303133 !important;
  }

  .intro-card p,
  .advantage-desc,
  .timeline-desc {
    color: #606266 !important;
  }

  // 保持浅色主题滚动条
  ::-webkit-scrollbar-track {
    background: #f5f5f5 !important;
  }

  ::-webkit-scrollbar-thumb {
    background: #2490ff !important;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #1976d2 !important;
  }

  // 联系我们区域 - 强制白色主题
  .contact-section .contact-background {
    // 保持原有的多彩渐变背景，但在深色模式下保持可见性
    background: linear-gradient(135deg, 
      #2490ff 0%, 
      #67c23a 25%, 
      #ff6b9d 50%, 
      #ff9068 75%, 
      #4facfe 100%) !important;
  }
  
  .contact-card {
    background: rgba(255, 255, 255, 0.95) !important;
    color: #303133 !important;
    border: 1px solid rgba(36, 144, 255, 0.2) !important;
    
    .contact-content h3 {
      color: #303133 !important;
    }
    
    .contact-content p {
      color: #606266 !important;
    }
    
    .email-badge {
      background: linear-gradient(135deg, #ff6b6b, #feca57) !important;
      color: white !important;
    }
    
    .partnership-tags .tag {
      background: rgba(36, 144, 255, 0.1) !important;
      color: #2490ff !important;
      border: 1px solid rgba(36, 144, 255, 0.3) !important;
    }
  }
  
  .contact-cta .cta-content {
    background: rgba(255, 255, 255, 0.95) !important;
    color: #303133 !important;
    border: 1px solid rgba(36, 144, 255, 0.2) !important;
    
    h3 {
      color: #303133 !important;
    }
    
    p {
      color: #606266 !important;
    }
  }
}
</style>